import { useState } from "react";
import { useAxios } from "@/app/providers/AxiosProvider";
import { uploadPortfolioVideo } from "./uploadPortfolioVideo";

export default function usePortfolioUpload() {
  const axios = useAxios();
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isUploadingVideo, setIsUploadingVideo] = useState(false);

  const upload = async (candidateUuid, file) => {
    setIsUploadingFile(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `/candidate/${candidateUuid}/portfolio/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } finally {
      setIsUploadingFile(false);
    }
  };

  const uploadImage = async (candidateUuid, file) => {
    setIsUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `/candidate/${candidateUuid}/portfolio/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } finally {
      setIsUploadingImage(false);
    }
  };

  /**
   * Upload a video directly to Cloudinary. See {@link uploadPortfolioVideo};
   * this wrapper only tracks the in-flight loading state.
   *
   * @returns {Promise<{url: string, public_id: string|null, original_filename: string}>}
   */
  const uploadVideo = async (candidateUuid, file, onProgress) => {
    setIsUploadingVideo(true);
    try {
      return await uploadPortfolioVideo(axios, candidateUuid, file, onProgress);
    } finally {
      setIsUploadingVideo(false);
    }
  };

  const isUploading = isUploadingFile || isUploadingImage || isUploadingVideo;

  return {
    upload,
    uploadImage,
    uploadVideo,
    isUploading,
    isUploadingFile,
    isUploadingImage,
    isUploadingVideo,
  };
}
